import { CustomComponentProps, PollObject } from "utils/types/generalTypes";
import SVG from "../core/SVG";

export type PollTextProps = CustomComponentProps & {
    poll: PollObject;
    updatePollOption: (
        option: string | FileList,
        optionOrder: 0 | 1 | 2
    ) => void;
    handleShowThirdPoll: () => void;
    handleRemoveThirdPoll: () => void;
};

const PollText = ({
    poll,
    updatePollOption,
    handleShowThirdPoll,
    handleRemoveThirdPoll,
    className,
    style
}: PollTextProps) => {
    return (
        <div
            className={`form-panel text-poll-panel ${className}`}
            style={style}
        >
            {/* first option  */}
            <div className="text-option-wrapper d-flex flex-j-between flex-a-start gap-10">
                <div className="field p-relative w-full">
                    <label>First Option</label>
                    <div className="control">
                        <input
                            type="text"
                            className="input"
                            placeholder="Your option"
                            value={poll.firstOption as string}
                            onChange={(e) =>
                                updatePollOption(e.target.value, 0)
                            }
                        />
                    </div>
                    <div className="float-char-length p-absolute momeento-p">
                        {poll.firstOption.length}/25
                    </div>
                </div>

                <span className="custom-is-hidden close-wrap d-flex flex-j-end mt-20">
                    <span className="custom-close-modal"></span>
                </span>
            </div>

            {/* second option  */}
            <div className="text-option-wrapper d-flex flex-j-between flex-a-start gap-10">
                <div className="field p-relative w-full">
                    <label>Second Option</label>
                    <div className="control">
                        <input
                            type="text"
                            className="input"
                            placeholder="Your option"
                            value={poll.secondOption as string}
                            onChange={(e) =>
                                updatePollOption(e.target.value, 1)
                            }
                        />
                    </div>
                    <div className="float-char-length p-absolute momeento-p">
                        {poll.secondOption.length}/25
                    </div>
                </div>

                <span
                    className={`close-wrap d-flex flex-j-end mt-20 ${poll.thirdOption != undefined ? "custom-is-hidden" : ""}`}
                >
                    <span
                        className={`custom-close-modal ${poll.thirdOption != undefined ? "is-disabled" : ""}`}
                        onClick={handleShowThirdPoll}
                    >
                        <SVG svg="plus" size={16} />
                    </span>
                </span>
            </div>

            {/* third option  */}
            {poll.thirdOption != undefined ? (
                <div className="text-option-wrapper d-flex flex-j-between flex-a-start gap-10">
                    <div className="field p-relative w-full">
                        <label>Third Option</label>
                        <div className="control">
                            <input
                                type="text"
                                className="input"
                                placeholder="Your option"
                                value={poll.thirdOption as string}
                                onChange={(e) =>
                                    updatePollOption(e.target.value, 2)
                                }
                            />
                        </div>
                        <div className="float-char-length p-absolute momeento-p">
                            {poll.thirdOption.length}/25
                        </div>
                    </div>

                    <span className="close-wrap d-flex flex-j-end mt-20">
                        <span
                            className="custom-close-modal"
                            onClick={handleRemoveThirdPoll}
                        >
                            <SVG svg="x" size={16} />
                        </span>
                    </span>
                </div>
            ) : (
                ""
            )}
        </div>
    );
};

export default PollText;
